import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-filter",
  "use": "icon-filter-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-filter\"><defs><style type=\"text/css\"></style></defs><path d=\"M981.333333 682.666667H509.866667c-10.24-72.106667-72.106667-128-147.2-128s-136.96 55.893333-147.2 128H42.666667v42.666666h172.8c10.24 72.106667 72.106667 128 147.2 128s136.96-55.893333 147.2-128H981.333333v-42.666666zM362.666667 810.666667a106.666667 106.666667 0 0 1 0-213.333334 106.666667 106.666667 0 0 1 0 213.333334zM661.333333 469.333333c75.093333 0 136.96-55.893333 147.2-128H981.333333V298.666667h-172.8c-10.24-72.106667-72.106667-128-147.2-128s-136.96 55.893333-147.2 128H42.666667v42.666666h471.466666c10.24 72.106667 72.106667 128 147.2 128z m0-256a106.666667 106.666667 0 0 1 0 213.333334 106.666667 106.666667 0 0 1 0-213.333334z\" p-id=\"1945\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/filter.svg
// module id = ObMl
// module chunks = 25